import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { HELP } from 'apps/auth/constants/UrlConstants';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';

const CashPickupLocationsPopup = ({ popupRef, banksList }) => {
    const { toSubSources } = useExtra();
    const messages = usePageMessages();
    const { country } = useApp();
    const { lang } = useLanguage();
    const helpLink = `${getLangCountryPrefix(lang, country)}${HELP}`;
    return (
        <>
            {banksList ? (
                <SimplePopup withoutBorder popupRef={popupRef}>
                    {banksList.map((bank) => (
                        <PopupButton
                            key={bank.code || bank.title}
                            title={bank.title}
                            text={bank.title}
                            href={bank.url}
                            iconName="arrow-forward"
                            target="_blank"
                        />
                    ))}
                </SimplePopup>
            ) : (
                <SimplePopup withoutBorder popupRef={popupRef}>
                    {toSubSources.map((s) => (
                        <PopupButton
                            key={s.prvId}
                            title={s.sourceName}
                            text={s.sourceName}
                            href={messages['unitellerLocations' + s.icon] || helpLink}
                            iconName="arrow-forward"
                            target="_blank"
                        />
                    ))}
                </SimplePopup>
            )}
        </>
    );
};
export default CashPickupLocationsPopup;
